import Controller from "./Controller.js";
import { trace } from 'rytm-helpers'
import { WCAG } from 'rytm-wcag'
import { setNavUpdateCallback, destroyNavUpdateCallback, getCollectionPrevTrigger, getCollectionNextTrigger, openNext, openPrev, getCurrentIndex, getCollectionTotal, getItems } from './../shared/collection-nav'
import { buildOwl, destroyOwl } from './../shared/owlcarousel'

/**
 * Odpowiada za nawigację poprzedni / następny obiekt
 */
class ObjectController extends Controller {
  
  /**
  * on view Swap complete - just before SHOW
  * @param {Event} e
  **/
  onViewSwapComplete(e) {
    super.onViewSwapComplete(e)
    setNavUpdateCallback(this.updateObjectNavState.bind(this))
    this.updateObjectNavState()
    this.updateObjectNavIndex()
    this.setupFocusTrap()
  }
  /**
  * Add event listeners called on <code>onViewShow()</code>
  **/
  addEventListeners() {
    super.addEventListeners();
  }
  /**
  * Remove event listeners called on <code>onViewHide()</code>
  **/
  removeEventListeners() {
    super.removeEventListeners();
    destroyNavUpdateCallback()
    this.destroyObjectNav()
    this.destroyFocusTrap()
  }
  /**
  * on view shown - animation in / show complete
  * @param {Event} e
  **/
  onViewShown(e) {
    super.onViewShown(e)
    this.onShownTransitionTimeout = setTimeout(() => {
      document.documentElement.classList.remove("object-nav-transition")
    }, 600)
  }
  onViewHidden(e) {
    super.onViewHidden(e)
  }
  /**
   * ###########
   * ### OWN ###
   */
  // aktualizuje indeks (np. 5 z 17)
  updateObjectNavIndex() {
    let ind = getCurrentIndex()
    let total = getCollectionTotal()
    if (ind > 0 && total > 0) {
      this.buildOwlCarousel(ind - 1)
      const container = document.querySelector(this.getContainerSelector())
      const indexWrapper = container.querySelector(".object-nav-index")
      if (indexWrapper) {
        const indexEl = indexWrapper.querySelector(".oni-ind")
        const totalEl = indexWrapper.querySelector(".oni-total")
        if (indexEl && totalEl) {
          indexEl.innerHTML = ind
          totalEl.innerHTML = total
          indexWrapper.classList.remove("d-none")
        }
      }
    }
  }
  // aktualizuje nawigację next / prev
  updateObjectNavState() {
    this.destroyObjectNav()
    const prevTrigger = getCollectionPrevTrigger()
    const nextTrigger = getCollectionNextTrigger()
    if (prevTrigger) {
      $("body").on("click", ".object-nav .nav-prev", $.proxy(this.onNavPrevClick, this))
      const prev = this.getNavLink(".nav-prev")
      if (prev) {
        prev.classList.remove("disabled")
      } else {
        trace("Prev is undefined")
      }
    }
    if (nextTrigger) {
      $("body").on("click", ".object-nav .nav-next", $.proxy(this.onNavNextClick, this))
      const next = this.getNavLink(".nav-next")
      if (next) {
        next.classList.remove("disabled")
      } else {
        trace("Next is undefined")
      }
    }
  }

  destroyObjectNav() {
    $("body").off("click", ".object-nav .nav-prev", $.proxy(this.onNavPrevClick, this))
    $("body").off("click", ".object-nav .nav-next", $.proxy(this.onNavNextClick, this))
    const prev = this.getNavLink(".nav-prev")
    const next = this.getNavLink(".nav-next")
    if (prev) {
      prev.classList.add("disabled")
    }
    if (next) {
      next.classList.add("disabled")
    }
  }
  getNavLink(selector) {
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      return container.querySelector(".object-nav " + selector)
    }
  }
  onNavPrevClick(e) {
    e.preventDefault()
    clearTimeout(this.onShownTransitionTimeout)
    document.documentElement.classList.add("object-nav-transition")
    openPrev()
  }
  onNavNextClick(e) {
    e.preventDefault()
    clearTimeout(this.onShownTransitionTimeout)
    document.documentElement.classList.add("object-nav-transition")
    openNext()
  }

  /**
   * OWL CAROUSEL
   */
  buildOwlCarousel(openIndex = 0) {
    this.destroyOwlCarousel()
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      const carousel = container.querySelector(".r-owl-carousel")
      const list = getItems()
      if (list.length > 1 && carousel) {
        container.classList.add("nav-carousel-active")
        list.forEach((el, index) => {
          const clone = el.cloneNode(true)
          clone.classList.remove("object-list")
          clone.classList.remove("object-loader")
          clone.classList.add("object-trigger")
          if (index == openIndex) {
            clone.classList.add("active")
          }
          carousel.appendChild(clone)
        })
        buildOwl(openIndex)
      }
    }
  }
  destroyOwlCarousel() {
    const container = document.querySelector(this.getContainerSelector())
    if (container) {
      container.classList.remove("nav-carousel-active")
      const carousel = container.querySelector(".r-owl-carousel")
      if (carousel) {
        carousel.innerHTML = ""
      }
    }
    destroyOwl()
  }

  setupFocusTrap() {
    const container = document.querySelector(this.getContainerSelector())
    const id = container?.id
    trace("## setup focus trap", id)
    if (id) {
      container.focus() 
      WCAG.dialogOpen(id, {dialog: container, toggleBtn: container.querySelector(".object-close")  })
    }

  }
  destroyFocusTrap() {
    const container = document.querySelector(this.getContainerSelector())
    const id = container?.id
    trace("destroy focus trap", id)
    if (id) {
      WCAG.dialogClose(id)
    }
  }

}
export default ObjectController